<template>
    <v-row v-if="messagesExist" class="review-message-container">
        <v-col cols="auto">
            <ul class="message-container">
                <li class="successMessages" v-for="(message, index) in successMessages"
                    :key="`success-${index}`">
                    {{message}}
                </li>
                <li class="needsConfirmationMessages"
                    v-for="(message, index) in needsConfirmationMessages"
                    :key="`needsConfirmation-${index}`">
                    {{message}}
                </li>
                <li class="errorMessages" v-for="(message, index) in errorMessages"
                    :key="`error-${index}`">
                    {{message}}
                </li>
            </ul>
        </v-col>
        <v-spacer/>
    </v-row>
</template>

<script>
    export default {
        name: 'MessageWrapper',
        props: [
            'messageWrapper'
        ],
        computed: {
            successMessagesExists: function () {
                return this.messageWrapper.SUCCESS && this.messageWrapper.SUCCESS.length > 0;
            },
            successMessages: function () {
                if (this.successMessagesExists) {
                    return this.messageWrapper.SUCCESS;
                } else {
                    return [];
                }
            },
            needsConfirmationMessagesExists: function () {
                return this.messageWrapper.NEEDS_CONFIRMATION && this.messageWrapper.NEEDS_CONFIRMATION.length > 0;
            },
            needsConfirmationMessages: function () {
                if (this.needsConfirmationMessagesExists) {
                    return this.messageWrapper.NEEDS_CONFIRMATION;
                } else {
                    return [];
                }
            },
            errorMessagesExists: function () {
                return this.messageWrapper.ERROR && this.messageWrapper.ERROR.length > 0;
            },
            errorMessages: function () {
                if (this.errorMessagesExists) {
                    return this.messageWrapper.ERROR;
                } else {
                    return [];
                }
            },
            messagesExist: function () {
                return this.successMessagesExists || this.needsConfirmationMessagesExists || this.errorMessagesExists;
            }
        }
    }
</script>

<style scoped>

    .review-message-container .message-container {
        list-style-type: '-  ';
        text-align: left;
    }

    .review-message-container .message-container .successMessages {
        color: #42b983;
    }

    .review-message-container .message-container .needsConfirmationMessages {
        color: #e7a34d;
    }

    .review-message-container .message-container .errorMessages {
        color: #b00020;
    }

</style>
